import axios from "axios";
import { BACKEND } from "./backend";

export const authClient = axios.create({
  baseURL: `${BACKEND}/api/auth`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const adminUsersClient = axios.create({
  baseURL: `${BACKEND}/api/admin`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const authApi = {
  login: async (email, password) =>
    (await authClient.post("/login", { email, password })).data,
  logout: async () => (await authClient.post("/logout")).data,
  me: async () => (await authClient.get("/me")).data,
  changePassword: async (current_password, new_password) =>
    (await authClient.post("/change-password", { current_password, new_password })).data,
};

export const adminUsersApi = {
  list: async () => (await adminUsersClient.get("/users")).data,
  create: async (payload) => (await adminUsersClient.post("/users", payload)).data,
  update: async (id, payload) =>
    (await adminUsersClient.patch(`/users/${id}`, payload)).data,
  resetPassword: async (id) =>
    (await adminUsersClient.post(`/users/${id}/reset-password`)).data,
};

// R10.5 — Audit + Error log (super_admin only)
export const adminAuditApi = {
  list: async (filters = {}) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => {
      if (v !== "" && v !== null && v !== undefined) params.set(k, v);
    });
    return (await adminUsersClient.get(`/audit?${params.toString()}`)).data;
  },
};

export const adminErrorsApi = {
  list: async (filters = {}) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => {
      if (v !== "" && v !== null && v !== undefined) params.set(k, v);
    });
    return (await adminUsersClient.get(`/errors?${params.toString()}`)).data;
  },
};
